<template>
    <center>
        <div class="game-container" v-if="jDat">
            <div class="container-fluid">
                <div class="row">
                    <h3 class="col-sm-3 hint-btn-img" v-if="jDat" @click="() => {this.hintVisible = !this.hintVisible}">Toggle Hint</h3>
                    <h3 class="col-sm-6" v-if="jDat">{{ jDat.pageTitle }}</h3>
                    <h3 class="col-sm-3" v-if="jDat">{{ timer }}</h3>
                </div>
                <div class="row position-relative">
                    <img v-if="hintVisible" :src="jDat.img" class="img-responsive col-12 position-absolute h-100" style="object-fit: contain; background: #121212dd;">
                    <canvas width="1000" height="500" id="jigsawCanvas"></canvas>
                </div>
                <div class="row audio-segment" v-if="this.isPuzzleComplete">
                    <div class="col-12" v-for="m in jDat.completedMusicFiles">
                        <span class="audio-container">
                            <span class="audio-title">{{ m.t }} || &nbsp;</span>
                            <audio controls controlsList="nodownload"><source :src="m.s" type="audio/mpeg"></audio>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="pieces" class="row hidden">
            <div :class="((i==0 || i == 4 || i == 8 || i == 12) ? 'col-2 offset-2' : 'col-2')" v-for="(dat,i) in this.pieces" style="background:#000000;">
                <h3 style="color:#D8D8D8">{{ dat.pos }}</h3>
                <img :src="dat.data" class="col-6" style="border:1px solid white;">
            </div>
        </div>
        <div class="question-overlay" v-if="currentQuestion" ref="questionOverlayBlock">
            <!--div class="row" -->
                <div class="col-12 col-sm-6 question-alert" v-if="questionAlertMsg"><h2>{{ questionAlertMsg }}</h2></div>
                <span class="col-12" :class="(questionAlertMsg == undefined) ? '' : 'hidden'">
                    <div class="col-12 col-sm-6 question-box" v-if="currentQuestion.t == 'mcq' || currentQuestion.t == 'hint'">
                        <h3>{{ currentQuestion.q }}</h3><hr>
                        <div class="row">
                            <a v-if="currentQuestion.t == 'mcq'" @click="answerQuestion(i)" class="col-12 answer-button mcq-btn" v-for="(a,i) in currentQuestion.a">{{ a }}</a>
                            <a v-if="currentQuestion.t == 'hint'" @click="answerQuestion(-1)" class="col-12 answer-button hint-btn">{{ currentQuestion.a }}</a>
                        </div><hr>
                    </div>
                    <div class="col-12 col-sm-6 question-box" v-if="currentQuestion.t == 'tf'">
                        <h3>{{ currentQuestion.q }}</h3><hr>
                        <div class="row">
                            <a @click="answerQuestion(1)" class="col-6 tf-btn tf-true">TRUE</a>
                            <a @click="answerQuestion(0)" class="col-6 tf-btn tf-false">FALSE</a>
                        </div><hr>
                    </div>
                    <div class="col-12 question-box" v-if="currentQuestion.t == 'ftb'">
                        <h3 class="mb-4 ftb-q" ref="ftbholder"></h3>
                    </div>
                </span>
            <!--/div -->
        </div>
        <b-modal id="jigsawModal" :hide-footer="true" centered ok-only>
            <center style="color:#21B100;font-size:1.5em;font-weight:400;" class="m-0" v-if="jDat">
                <h3>Congratulations</h3>
                <p>Puzzle completed in {{ this.timer }}</p>
                <p style="color:black;" v-if="jDat.completedMusicFiles.length > 0">Audio snippets unlocked, please close this popup to listen.</p>
            </center>
        </b-modal>
    </center>
</template>
<script>
    import { ajaxGet,ajaxPost } from "../../../ajax";
    import { JigsawGenerator } from "./jigsawjsgen.js";
    import { JigsawGame } from "./jigsawgame.js";
    import {apiUrl} from "@/main";
    export default{
        data(){
            return {
                hintVisible: false,
                jDat: undefined,
                pieces: undefined,
                jobj: undefined,
                currentQuestion: undefined,
                questionAlertMsg: undefined,
                answerObj: [],
                currentQuestionIndex: undefined,
                answerMessage: undefined,
                answerBody: {
                    timeTaken: "",
                    answers: []
                },
                totalAnswered: undefined,
                jigsawId: undefined,
                buffer: undefined,
                timer: "00:00:00",
                timerInterval: undefined,
                isPuzzleComplete: undefined
            }
        },
        mounted(){
            //after data load
            // this.init();
            // console.log(JSON.stringify(this.jDat));
            this.jigsawId = this.$router.history.current.params.jigsawId;
            // console.log(this.$router.history.current.query.Assignment);
            // ajaxGet("http://api.dex/jigsaw.php",
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.jigsawId,
                (dat) => {
                    //on success dat is called
                    if(dat.component == "jigsaw"){
                        //This is the right component
                        this.jDat = dat.data;
                        this.isAnswered = dat.answers;
                        this.jDat.pageTitle = dat.title;
                        window.document.title = dat.title;
                        this.init();
                    }else{
                        //Wrong component type
                        console.error("DATA MISMATCH on api call expected 'JIGSAW' object, got '" + dat.component.toUpperCase() + "' object.");
                    }
                },(err) => {
                    //There was some error
                    console.log(err);
                }, localStorage.token, this);
        },
        methods: {
            init(){
                // console.log((JSON.stringify(this.jDat)));
                this.isPuzzleComplete = false;
                this.hintVisible = false;
                this.timerStartTime = Date.now();
                if(this.timerInterval) clearInterval(this.timerInterval);
                this.timerInterval = setInterval(() => {
                    this.timer = new Date(Date.now() - this.timerStartTime).toISOString().substr(11, 8);
                    this.answerBody.timeTaken = this.timer;
                    // console.log(JSON.parse(JSON.stringify(this.answerBody)));
                },1000);
                this.jobj = new JigsawGenerator();
                this.totalAnswered = 0;
                this.jobj.onSplitDone = this.setPieces;
                this.jobj.generatePuzzle(this.jDat.img);
                this.answerBody = {
                    timeTaken: "",
                    answers: []
                };
            },
            ftbGenerator(dat){
                var parent = this.$refs.ftbholder;
                // console.log("PARENT", parent);
                if(parent == undefined) return null;
                parent.innerHTML = "";
                // console.log("PARENT:",parent);
                // console.log("FUNC", this.answerQuestion);
                // return null;
                dat = dat.split("||--FTB--||");
                dat.forEach((el,i) => {
                    var span = document.createElement('span');
                    span.innerHTML = el;
                    parent.appendChild(span);
                    if(i+1 < dat.length){
                        var a = document.createElement('a');
                        a.id = "gtb-jigsaw-answer-" + i;
                        a.innerHTML = (this.answerObj[i] != undefined) ? this.answerObj[i] : "<b>[----------]</b>";
                        a.addEventListener("click", (e) => {
                            if(e.target.innerHTML == "<b>[----------]</b>") return null;
                            var c = prompt("Your answer:", '');
                            if(!c) return null;
                            // console.log("E", e);
                            this.answerQuestion(c, i)
                        });
                        parent.appendChild(a);
                    }
                });
                return "";
            },
            setPieces(dat){
                if(!dat) return null;
                var x = this;
                x.pieces = [];
                dat.forEach((el,i) => {
                    x.pieces.push(el);
                });
                this.jobj = new JigsawGame(this.pieces, document.getElementById("jigsawCanvas"), this.askQuestion);
            },
            askQuestion(ind = undefined){
                if(ind == undefined) return null;
                ind = ind.slice('');
                var x = parseInt(ind[0]) + (parseInt(ind[0]) * 3) + parseInt(ind[1]);
                this.currentQuestion = this.jDat.questions[x];
                this.currentQuestionIndex = (ind);
                // console.log(this.currentQuestion);
                if(this.currentQuestion.t == "ftb"){
                    setTimeout(() => {
                        this.ftbGenerator(this.currentQuestion.q);
                    }, 100);
                }
                // console.log(x);
                // this.currentQuestion = this.jDat.questions[ind];
                // this.currentQuestionIndex = ind;
                // this.answerMessage = undefined;
                // this.$bvModal.show("jigsawModal");
                // console.log("SOME QUESTION HAPPENS", JSON.parse(JSON.stringify(obj)));
            },
            doAlert(state){
                var col = (state == 0) ? '#FF020299' : '#1BFC0499';
                var msg = (state == 0) ? 'Wrong Answer!' : 'Correct!';
                // console.log(msg, col);
                this.questionAlertMsg = msg;
                this.$refs.questionOverlayBlock.style.background = col;
                clearTimeout(this.buffer);
                this.buffer = setTimeout(() => {
                    this.questionAlertMsg = undefined;
                    if(this.currentQuestion == undefined) return null;
                    this.$refs.questionOverlayBlock.style.background = "none";
                }, 1500);
            },
            puzzleCompleted(){
                this.isPuzzleComplete = true;
                console.log(JSON.parse(JSON.stringify(this.answerBody)));
                clearInterval(this.timerInterval);
                //PERFORM AJAX REQUEST HERE
                //----------------------------------------------------
                if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                    this.answerBody.completedOn = Date.now();
                    ajaxPost(apiUrl() +"/assignments/" + this.jigsawId, {
                        Data: (this.answerBody)
                    },
                    (suc) => {
                        console.log("Posted assignment:", suc);
                    },
                    (err) => {
                        console.log("Error :", err)
                    }, localStorage.token);
                }
                //----------------------------------------------------
                //AJAX REQUEST CODE ENDS HERE
                this.$bvModal.show("jigsawModal");
            },
            answerQuestion(i, ftbi = undefined){
                /*background: #FF020299; FAIL*/
                /*background: #1BFC0499; SUCCESS*/
                var correctStatus = false;
                if(this.currentQuestion.t == "ftb"){
                    //this is a fill in the blank thing!
                    if(i.toLowerCase() == this.currentQuestion.a[ftbi].toLowerCase()){
                        document.getElementById("gtb-jigsaw-answer-" + ftbi).innerHTML = i;
                        this.doAlert(1);
                        this.answerObj[ftbi] = i;
                        correctStatus = true;
                        if(this.answerObj.length == this.currentQuestion.a.length){
                            this.totalAnswered += 1;
                            this.answerBody.answers.push({
                                question: this.currentQuestion,
                                answer: this.answerObj
                            });
                            setTimeout(() => {
                                this.currentQuestion = undefined;
                                this.answerObj = [];
                            }, 1500);
                        }
                    }else{
                        this.doAlert(0);
                        setTimeout(() => {
                            this.currentQuestion = undefined;
                            this.answerObj = [];
                        }, 1500);
                    }
                }else if(this.currentQuestion.t == "hint"){
                    this.totalAnswered += 1;
                    this.answerBody.answers.push({
                        question: this.currentQuestion,
                        answer: '1'
                    });
                    this.currentQuestion = undefined;
                    this.answerObj = [];
                    correctStatus = true;
                }else if(this.currentQuestion.t == "mcq"){
                    if(i == this.currentQuestion.i){
                        this.answerBody.answers.push({
                            question: this.currentQuestion,
                            answer: i
                        });
                        correctStatus = true;
                        this.totalAnswered += 1;
                        setTimeout(() => {
                            this.currentQuestion = undefined;
                            this.answerObj = [];
                        }, 1500);
                        this.doAlert(1);
                    }else{
                        this.doAlert(0);
                        setTimeout(() => {
                            this.currentQuestion = undefined;
                            this.answerObj = [];
                        }, 1500);
                    }
                }else if(this.currentQuestion.t == "tf"){
                    if(i == this.currentQuestion.a){
                        this.answerBody.answers.push({
                            question: this.currentQuestion,
                            answer: i
                        });
                        correctStatus = true;
                        this.totalAnswered += 1;
                        setTimeout(() => {
                            this.currentQuestion = undefined;
                            this.answerObj = [];
                        }, 1500);
                        this.doAlert(1);
                    }else{
                        this.doAlert(0);
                        setTimeout(() => {
                            this.currentQuestion = undefined;
                            this.answerObj = [];
                        }, 1500);
                    }
                }

                // console.log("Correct Status:", correctStatus, this.currentQuestionIndex);
                if(correctStatus == false){
                    this.jobj.resetPiece(this.currentQuestionIndex);
                }
                if(this.totalAnswered == 16){
                    console.log("Answer Message:", JSON.parse(JSON.stringify(this.answerBody)));
                    this.puzzleCompleted();
                }
            }
        }
    }
</script>
<style scoped>
.audio-segment .audio-container{
    display: flex;
    width: 100%;
    justify-content: center;
}
.audio-segment .audio-title{
    align-self: center;
    font-weight: 500;
    font-size: 1.2em;
}
.hint-btn-img{
    cursor:pointer;
    background: #e65100;
    border-radius: 3px;
}
.game-container{
    width: 1000px;
    background: #121212;
    color: white;
}
    .hidden{
        display: none;
    }
    .question-alert{
        color: white;
        font-weight: 900;
        background: #121212;
        border-radius: 10px;
    }
    .ftb-q /deep/ a{
        background: #d84315;
        cursor: pointer;
    }
    .ftb-q /deep/ a:hover{
        background: #f4511e;
        cursor: pointer;
    }
    .question-overlay{
        position:fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(4px) grayscale(30%) saturate(150%);
        transition: all 0.5s ease;
    }
    .question-box{
        opacity: 0.8;
        color: #efefef;
        background-image: none;
        box-shadow: none;
        background: #121212;
        transition: all 0.3s ease;
        border: 2px solid #FF0072;
        border-radius: 10px;
    }
    .question-box:hover{
        opacity: 0.9;
    }
    .question-box h3{
        margin-top: 1em;
    }
    .question-box .answer-button{
        background: #232323;
        padding: 0.5em;
        cursor: pointer;
        border-bottom: 1px solid #434343;
        transition: all 0.2s ease;
    }
    .question-box .answer-button:hover{
        background: #323232;
    }
    .question-box .answer-button:active{
        background: #434343;
    }
    .question-box .row{
        border-top: 1px solid #434343;
    }
    .question-box .tf-btn{
        border-bottom: 1px solid #434343;
        padding: 0.5em  0.2em;
        cursor:pointer;
        transition: all 0.2s ease;
    }
    .question-box .tf-true{ background: #2e7d32; color: #efefef; }
    .question-box .tf-true:hover{ background: #558b2f; color: #efefef; }
    .question-box .tf-false{ background: #c62828; color: #efefef; }
    .question-box .tf-false:hover{ background: #e53935; color: #efefef; }
    .question-box .hint-btn{ background: #4527a0; color: #efefef; }
    .question-box .hint-btn:hover{ background: #673ab7; color: #efefef; }
    .question-box .mcq-btn{ background: #2e7d32; color: #efefef; }
    .question-box .mcq-btn:hover{ background: #558b2f; color: #efefef; }
    center{
        margin-top: 60px;
    }
    canvas{
        background: url(../../../../public/jigsaw/ui.jpg);
    }
    .hidden{
        display: none;
    }
    h1{
        color: white !important;
    }
</style>